<template>
  <base-account>
    <section class="section hero-section bg-ico-hero" id="home">
      <div class="bg-overlay bg-primary"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-12 col-lg-8 col-xl-8">
            <div class="card overflow-hidden">
              <div class="bg-soft-primary">
                <div class="row">
                  <div class="col-7">
                    <div class="text-primary p-4">
                      <h5 class="text-primary">Redefinir sua senha</h5>
                      <p>Insira o CPF e e-mail que você usou no cadastro.<br>
                        Nós mandaremos um e-mail com um link para você redefinir sua senha.</p>
                    </div>
                  </div>
                  <div class="col-5 align-self-end">
                    <img src="@/assets/images/profile-img.png" alt class="img-fluid"/>
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <Loader :loading="httpSend">
                  <div class="p-2">
                    <div role="alert" v-show="resposta.status" aria-live="polite" aria-atomic="true"
                         class="alert alert-success mt-2">
                      <i class="mdi mdi-check-all mr-2"></i> {{ resposta.mensagem }}
                    </div>
                    <div role="alert" v-show="resposta.status === false" aria-live="polite" aria-atomic="true"
                         class="alert alert-danger mt-2">
                      <i class="mdi mdi-block-helper mr-2"></i> {{ resposta.mensagem }}
                    </div>
                    <form v-show="!resposta.status" @submit.prevent="tryToReset">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="pes_cpfcnpj">CPF</label>
                            <the-mask
                                type="text"
                                v-model="pes_cpfcnpj"
                                class="form-control"
                                id="pes_cpfcnpj"
                                placeholder=""
                                :class="{ 'is-invalid': submitted && $v.pes_cpfcnpj.$error }"
                                :mask="['###.###.###-##']"/>
                            <div v-if="submitted && $v.pes_cpfcnpj.$error" class="invalid-feedback">
                              <span v-if="!$v.pes_cpfcnpj.required">Informe o CPF de acesso</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="pes_mail">E-mail</label>
                            <input
                                type="email"
                                v-model="pes_mail"
                                class="form-control"
                                id="pes_mail"
                                placeholder="Enter email"
                                :class="{ 'is-invalid': submitted && $v.pes_mail.$error }"
                            />
                            <div v-if="submitted && $v.pes_mail.$error" class="invalid-feedback">
                              <span v-if="!$v.pes_mail.required">Informe o e-mail de acesso</span>
                              <span v-if="!$v.pes_mail.email">Informe um e-mail válido</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group row mb-0">
                        <div class="col-12 text-right">
                          <button class="btn btn-primary w-md" type="submit">
                            Redefinir
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </Loader>
              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->

            <div class="mt-5 text-center text-white">
              <p>
                Já possui conta ?
                <router-link
                    tag="a"
                    to="/"
                    class="font-weight-medium text-danger">Login
                </router-link>
              </p>
            </div>
          </div>
          <!-- end col -->
        </div>
      </div>
    </section>
  </base-account>
</template>

<script>
import {TheMask} from 'vue-the-mask'
import Loader from "@/components/widgets/loader"
import appConfig from "@/dados/app.config.json";
import BaseAccount from "@/router/layouts/base-account"
import {required, email} from "vuelidate/lib/validators";
import {setSolicitacaoRecuperacao} from "@/api/login/auth";

export default {
  page: {
    title: "Forgot Password",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    BaseAccount,
    TheMask,
    Loader
  },
  data() {
    return {
      pes_cpfcnpj: "",
      pes_mail: "",
      submitted: false,
      error: null,
      tryingToReset: false,
      isResetError: false,
      httpSend: false,
      resposta: {
        status: null,
        mensagem: ''
      },
    };
  },
  validations: {
    pes_cpfcnpj: {
      required,
    },
    pes_mail: {
      required,
      email,
    },
  },
  methods: {
    tryToReset() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let dados = {
          pes_cpfcnpj: this.pes_cpfcnpj,
          pes_mail: this.pes_mail,
          dominio: window.location.origin
        }
        this.resposta.status = null;
        this.resposta.mensagem = null;
        this.httpSend = true;
        setSolicitacaoRecuperacao(dados).then(response => {
          this.resposta = response
        }).catch(error => {
          console.log(error);
        }).finally(() => {
          this.httpSend = false
        })
      }
    },
  },
};
</script>

<style lang="scss" module></style>
